export default __webpack_public_path__ + "static/media/NFD_Minting_Guide1024_5.b5843f6f.png";